import React from "react";

export default function ResultadoUpload({ arquivos }) {
    if (!arquivos || arquivos.length === 0) return null;

    function formatBytes(bytes) {
        if (bytes === 0) return '0 B';
        const k = 1024;
        const sizes = ['B', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }

    return (
        <div className="resultado-upload">
            <h4>Arquivos enviados com sucesso:</h4>
            <div style={{ placeSelf: 'flex-start', textAlign: 'left' }}>
                <ul>
                    {arquivos.map((file, i) => (
                        <>
                            <li key={i}>✅ {file.file.name.length > 100 ? file.file.name.slice(0, 100) + '...' : file.file.name} -
                                <span style={{ fontSize: '0.7em' }}>{formatBytes(file.file.size)}</span></li>
                        </>
                    ))}
                </ul>
            </div>
        </div>
    );
}
